import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsCommentsBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Comments</div>
          <div className="text">
            Users and admins can leave comments on posts. Therefore, comment objects are always
            associated with a post. The API allows you to fetch a specific comment, or a list of
            comments for a&nbsp;post.
          </div>
        </div>
        <div></div>
      </APIDocsBlock>
    );
  }
}
